import useApi from "../../utils/useApi";

export const useAuthClient = () => {
    const apiCall = useApi({name:"AuthClient"});

    return {
        fetchAssets: async (locale, region) => await apiCall(region ? `comicbook/assets/${locale}/${region}` : `comicbook/assets/${locale}`, "GET")(),
        fetchProfile: apiCall("comicbook/profile", "GET"),
        logout: apiCall("comicbook/logout", "POST", false),
    }
}
export default useAuthClient ;
